import { render, staticRenderFns } from "./SavedAndWishlist.vue?vue&type=template&id=03a42cf4&"
import script from "./SavedAndWishlist.vue?vue&type=script&lang=js&"
export * from "./SavedAndWishlist.vue?vue&type=script&lang=js&"
import style0 from "./SavedAndWishlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SavedAndWishlist.vue"
export default component.exports